import React from "react";

import { Props } from "./types";

function ResourcesIcon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      width="21.439"
      height="29.653"
      viewBox="0 0 21.439 29.653"
    >
      <g
        id="Groupe_10987"
        data-name="Groupe 10987"
        transform="translate(-1800.053 -392.174)"
      >
        <path
          id="Tracé_4493"
          data-name="Tracé 4493"
          d="M17.4,6.289a2.019,2.019,0,1,0-2.019-2.019A2.012,2.012,0,0,0,17.4,6.289Z"
          transform="translate(1792.7 389.924)"
          fill="#989898"
        />
        <path
          id="Tracé_4494"
          data-name="Tracé 4494"
          d="M18.666,8.086H14.616a2.592,2.592,0,0,0-2.523,2.62v6.15a.841.841,0,1,0,1.678,0V11.172H14.1V26.633a1.165,1.165,0,1,0,2.328,0V17.722h.433v8.916a1.165,1.165,0,1,0,2.328-.005V11.172h.271v5.684a.867.867,0,1,0,1.732,0v-6.15A2.6,2.6,0,0,0,18.666,8.086Z"
          transform="translate(1793.456 388.581)"
          fill="#989898"
        />
        <path
          id="Tracé_4493-2"
          data-name="Tracé 4493"
          d="M17.4,6.289a2.019,2.019,0,1,0-2.019-2.019A2.012,2.012,0,0,0,17.4,6.289Z"
          transform="translate(1787.204 395.313)"
          fill="#232F34"
        />
        <path
          id="Tracé_4494-2"
          data-name="Tracé 4494"
          d="M18.666,8.086H14.616a2.592,2.592,0,0,0-2.523,2.62v6.15a.841.841,0,1,0,1.678,0V11.172H14.1V26.633a1.165,1.165,0,1,0,2.328,0V17.722h.433v8.916a1.165,1.165,0,1,0,2.328-.005V11.172h.271v5.684a.867.867,0,1,0,1.732,0v-6.15A2.6,2.6,0,0,0,18.666,8.086Z"
          transform="translate(1787.959 393.97)"
          fill="#232F34"
        />
        <path
          id="Tracé_4495"
          data-name="Tracé 4495"
          d="M12.9,9.9l-1.592,5.646c-.341,1.234,1.121,1.716,1.478.558L14.207,10.9h.4L12.16,20.05h2.285v6.875a.869.869,0,1,0,1.732,0V20.05h.541v6.875a.844.844,0,1,0,1.678,0V20.05h2.349l-2.5-9.149H18.7l1.424,5.208c.352,1.186,1.8.677,1.478-.552L20.01,9.9a2.689,2.689,0,0,0-2.274-1.819H15.176A2.584,2.584,0,0,0,12.9,9.9Z"
          transform="translate(1799.843 393.967)"
          fill="#232F34"
        />
        <path
          id="Tracé_4496"
          data-name="Tracé 4496"
          d="M19.389,4.262a1.982,1.982,0,1,0-1.981,2.019A2,2,0,0,0,19.389,4.262Z"
          transform="translate(1798.883 395.312)"
          fill="#232F34"
        />
      </g>
    </svg>
  );
}

export { ResourcesIcon };
